<div class="not-found">
  <div class="not-found-card">
    <img class="cal-logo" src="assets/images/logo/cal-logo-2x.png" alt="CAL" />
    <p class="code">404</p>
    <h1>Page not found</h1>
    <p class="message">The page you are looking for does not exist or may have been moved.</p>
    <a class="home-link" routerLink="/signin">Back to sign in</a>
  </div>
</div>
